import { TopMenu } from './TopMenu';

export default TopMenu;
